<template>
  <div class="table-list">
    <el-row class="rowTop">
      <table-top :table-top="Toptitle"></table-top>
      <div class="table-header clearfix">
        <div><el-button type="primary" size="mini" @click="dialogVisible=true">紧急通知</el-button></div>
        <!-- <div class="f-right w240">
          <el-input placeholder="请输入消息标题" v-model="search.nameLike">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
      </div>
    </el-row>  
    <el-row>
      <el-col class="table-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          @row-click="rowClick"
        >
          <el-table-column
            label="消息标题"
            prop="title"
            width="300px"
            show-overflow-tooltip>
          </el-table-column>
         
          <el-table-column
            label="消息内容"
            prop="content"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-html="scope.row.content"></div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            prop="time"
            label="时间"
            width="180"
          >
          </el-table-column>
          <!-- <el-table-column
            fixed="right"
            label="操作"
            width="80px"
          >
            <template slot-scope="scope">
              <el-button @click="detailClick(scope.row)" size="mini">查看</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <page-size ref="child" :search="search" :table-data="tableData" :data-url="getListURL" @changeData="changeData" @changeTotal="changeTotal"></page-size>
      </el-col>
    </el-row>
    <el-dialog title="紧急通知" :visible.sync="dialogVisible">
      <el-form>
        <el-form-item label="通知内容" label-width="100">
          <el-input type="textarea" v-model="content" auto-complete="off"></el-input>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendNotice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import TableTop from '@/components/TableTop'
  import PageSize from '@/components/PageSize'
  import {messageListURL, sendEmergencyNoticeURL, ifMessageURL} from '@/api/http'
  export default {
    components: {
      TableTop,
      PageSize
    },
    data () {
      return {
        select: '',
        dialogVisible: false,
        getListURL: messageListURL,
        Toptitle: '消息管理',
        tableData: [],
        content: '',
        multipleSelection: [],
        search: {
          nameLike: ''
        },
        isTrue: false
      }
    },
    methods: {     
      changeTotal (total) {
        this.Toptitle = '消息管理（共'+total+'条）'
      },
      changeData (tableData) {
        this.tableData = tableData
      },
      rowClick(row) {
        if (!row.businessBlock) {
          this.$message.warning('该消息没有详情信息')
        } else {
          let url = ''
          if (row.url) {
            url = row.url.split('/')[row.url.split('/').length-1]  
          }
          const id = row.id         
          if (row.businessBlock=='task') {                  
            this.ifMessageTrue(id,'/todoDetail',url, '','流程已处理！可在已办理事宜中查看详情')
          } else if(row.businessBlock=='historyProcess'){        
            this.ifMessageTrue(id,'/todoDetail',url, 'process', '流程已删除')
          } else if(row.businessBlock=='notice'){        
            this.ifMessageTrue(id,'/noticeDetails',url, '', '公告已删除')
          } else if(row.businessBlock=='workLog'){        
            this.ifMessageTrue(id,'/gongZuorz',url)
          } else if(row.businessBlock=='vote'){        
            this.ifMessageTrue(id,'/voteManagement/voteDetail',url, '', '投票已删除')
          } else if(row.businessBlock=='workPlan'){        
            this.ifMessageTrue(id,'/workPlanDetai',url,'', '计划已删除')
          } else if(row.businessBlock=='schedule'){        
            this.ifMessageTrue(id,'/schedule',url)
          } else if(row.businessBlock=='commonFile'){        
            window.open('http://'+row.url)
          }
        }
      },
      ifMessageTrue (id,path,url,type,text) {
        this.$http.get(ifMessageURL+id+'/url/validate')
          .then(res => {
            console.log(res,id,path,url,type,text)
              if(res) {
                this.$router.push({
                  path: path, 
                  name: '',
                  params: { 
                    id: url,
                  },
                  query: { 
                    id: url,
                    type: type
                  }
                })
              } else {
                this.$message.warning(text)
              }
          })
          .catch(err => {
            console.log(err)
          })
      },
      sendNotice () {
        this.$http.post(sendEmergencyNoticeURL, {content: this.content})
          .then(res => {
            console.log(res)
            if (res.msg) {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            } else {
              this.$message({
                message: '发送成功',
                type: 'success'
              });
              this.dialogVisible = false
            }
          })
          .catch(err => {
            console.log(err)
          })　  
      }
    }
  }
</script>
<style lang="less" scoped>

</style>




// WEBPACK FOOTER //
// src/pages/messageManagement/index.vue